import type { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

const SwPageContent: FC<PropsWithChildren<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>>> = ({
    children,
    ...rest
}) => {
    return (
        <div {...rest}>
            <div className="sw-layout-research">
                <div className="sw-layout-page">{children}</div>
            </div>
        </div>
    );
};

export default SwPageContent;
